import React from 'react';
import { CHECKOUT_URL, PRICE } from '../data/offer';
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-carbon-line bg-carbon-800/95 px-4 py-3 backdrop-blur sm:hidden" data-id="element-156" data-mp="1oy5epgpp3l7s">
      <div className="flex items-center gap-3" data-id="element-157" data-mp="1t0s1h37iefy4">
        <div className="shrink-0" data-id="element-158" data-mp="1xz3bbdxt0qgc">
          <p className="font-display text-xl leading-none text-paper" data-id="element-159" data-mp="1xyadj2gtpbac">{PRICE}</p>
          <p className="text-[11px] text-paper-dim line-through" data-id="element-160" data-mp="119m6f16nb8fp">$552</p>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex flex-1 items-center justify-center rounded-full bg-mint px-5 py-3.5 text-center font-display text-sm uppercase leading-tight tracking-wide text-carbon-900 transition-colors duration-150 ease-out hover:bg-mint-deep" data-id="element-161" data-mp="15aegtxr97jdk">
          Get the pack now
        </a>
      </div>
    </div>;
}